/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DomainUiLightDto } from './DomainUiLightDto';

export type AccessTokenUiDto = {
    createdBy: string;
    createdDate: number;
    domains: Array<DomainUiLightDto>;
    expiryDate: number;
    id: string;
    isExpired: boolean;
    lastUsed?: number;
    name: string;
    role: AccessTokenUiDto.role;
};

export namespace AccessTokenUiDto {

    export enum role {
        ADMIN = 'Admin',
        EDITOR = 'Editor',
        VIEWER = 'Viewer',
        AGENT_SERVICE_ACCOUNT = 'Agent Service Account',
    }


}
